var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RequestsList',{attrs:{"shop-id":2,"shop-name":"فروشگاه"}})
}
var staticRenderFns = []

export { render, staticRenderFns }